import { styled } from 'linaria/react';
import { css } from 'linaria';

export const HeaderContainer = styled.div`
  margin-bottom: var(--space-125);
`;

export const SelectionGroupClassname = css`
  display: flex;
  gap: var(--space-200);

  @media (--only-mobile) {
    gap: var(--space-150);
  }
`;

export const SelectionGroupContent = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;
